import {qs} from './qs'

export default (basePath, otherApi) => ({
  getList: query => ({
    url: `${basePath}${qs(query, '?')}`,
    method: 'GET'
  }),
  getPageList: query => ({
    url: `${basePath}/page-list${qs(query, '?')}`,
    method: 'GET'
  }),
  getDetail: id => ({
    url: `${basePath}/${id}`,
    method: 'GET'
  }),
  save: (model, methodType) => ({
    url: basePath,
    method: methodType === 1 ? 'POST' : 'PUT',
    data: model
  }),
  delete: id => ({
    url: `${basePath}/${id}`,
    method: 'DELETE'
  }),
  getOptions: (query = {}) => ({
    url: `${basePath}${qs(query, '?')}`,
    method: 'GET'
  }),
  changeStatus: (id, status) => ({
    url: `${basePath}/status`,
    method: 'PUT',
    data: {
      id,
      status
    }
  }),
  ...(otherApi || {})
})



// WEBPACK FOOTER //
// ./src/apis/curd.js